import { useMemo } from 'react'

const AnswerVariant = ({ isActive, value, onSelect, index }) => {
  const bgClassName = isActive ? 'bg-[#F89B22] text-white' : 'bg-white text-primary-75'

  const handleSelect = () => {
    onSelect(index + 1)
  }

  const getAphabetLabel = useMemo(() => {
    const charCodeOfA = 'a'.charCodeAt(0)
    return String.fromCharCode(charCodeOfA + index).toUpperCase()
  }, [])

  return (
    <button
      type="button"
      onClick={handleSelect}
      className={`w-full text-left !py-4 !mb-1 px-[14px] border !border-primary-100 rounded-[4px] hover:cursor-pointer ${bgClassName}`}
    >
      {`${getAphabetLabel}. ${value}`}
    </button>
  )
}

export default AnswerVariant
